<template>
  <transition>
    <div class="wim-focus-component" :id="'wim-focus-'+content.id">
      <div class="wim-close-container">
        <div class="wim-close-button" @click="closeFocus">
          <div class="line-1"></div>
          <div class="line-2"></div>
        </div>
      </div>
      <div class="wim-focus-container tva-row">
        <!-- info fisse sinistra -->
        <div class="wim-focus-titles tva-col-sm-offset-1 tva-col-sm-2">
          <div class="wim-focus-smallname"><h5 class="white">{{content.smallText}}</h5></div>
          <div class="wim-focus-title"><h3 v-html="content.title">{{content.title}}</h3></div>

          <div>
            <!-- image mobile -->
            <div v-if="$mq === 'mobile' && content.image" class="wim-focus-picture">
              <img v-lazy="`${baseUrl}images${$mq === 'mobile' ? '-mobile' : ''}/${content.image}${$retina ? '@2x' : ''}.jpg`" alt="image">
            </div>
            <h6 class="wim-focus-name" v-html="content.name">{{content.name}}</h6>
          </div>

          <!-- image desktop -->
          <div v-if="$mq !== 'mobile' && content.image" class="wim-focus-picture">
            <img v-lazy="`${baseUrl}images${$mq === 'mobile' ? '-mobile' : ''}/${content.image}${$retina ? '@2x' : ''}.jpg`" alt="image">
          </div>

        </div>
        <!-- contenuto scrollabile -->
        <div class="wim-focus-content tva-col-sm-offset-4 tva-col-sm-6">
          <div v-for="(element, index) in content.content" :key="index" class="wim-focus-section">
            <!-- paragrafo -->
            <div class="wim-focus-paragraph" v-if="element.type === 'paragraph'"> <p class="white" v-html="element.content"></p></div>
            <!-- audio + cit -->
            <div class="wim-focus-quote" v-if="element.type === 'quote'"> 
              <div v-if="element.audio" class="wim-focus-quote-svg" @click="toggleAudio(element.audio)" >
                <img v-if="play === false" src="/images/play.svg"/>
                <img v-else src="/images/pause.svg"/>
              </div>
              <p class="red wim-focus-quote-text">{{element.quote}}</p>
            </div>
            <!-- immagine -->
            <div class="wim-focus-image" v-if="element.type === 'image'"> 
              <img v-lazy="`${baseUrl}images${$mq === 'mobile' ? '-mobile' : ''}/${element.image}${$retina ? '@2x' : ''}.jpg`" alt="image">
            </div>
            <!-- video -->
            <div class="wim-focus-video" v-if="element.type === 'video'"> 
              <video 
                :poster="`${baseUrl}images${$mq === 'mobile' ? '-mobile' : ''}/${element.image}${$retina ? '@2x' : ''}.jpg`"
                controls
              >
                <source :src="`${baseUrl}images${$mq === 'mobile' ? '-mobile' : ''}/${element.image}.mp4`" type="video/mp4">
              </video>
            </div>
          </div>
        </div> 
      </div>
    </div>
  </transition>
</template>

<script>
import VueScrollTo from "vue-scrollto";
import {Howl, Howler} from 'howler';

export default {
  beforeCreate() {
    let focusId = +this.$route.params.focusId;
    this.content = _.filter(this.$ml.get('focus'), d => d.id === focusId)[0]
  },
  mounted() {
    VueScrollTo.scrollTo(`.wim-focus-component`, 1);
  },
  data() {
    return {
      content: {}
    }
  },
  methods: {
    closeFocus() {
      if (this.audio) this.audio.pause();
      this.audio = null;
      this.$router.push(`/${this.$ml.current}#wim-focus-preview-${this.content.id}`)
    },
    toggleAudio(name) {
      this.play = !this.play;

      if (!this.audio) {
        this.audio = new Howl({
          src: [`${this.baseUrl}images/${name}.ogg`, `${this.baseUrl}images/${name}.mp3`],
          autoplay: false,
          loop: false,
          html5: true
        });
      }

      if (this.play) {
        if (this.audio) this.audio.play()
      } else {
        if (this.audio) this.audio.pause()
      }
    }
  },
   data() {
    return {
      audio: null,
      play: false,
      baseUrl: process.env.BASE_URL
    };
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/scss/colors.scss";
@import "../assets/scss/fonts.scss";

.wim-focus-component {
  background: $black;
  min-height: 100vh;
}
.wim-close-container {
  position: fixed;
  width: 100%;
  padding: 0 3%;
  height: 10vh;
  background: $black;
  z-index: 8;
  box-shadow: 0px 10px 40px rgba($black, 0.6);
  .wim-close-button {
    position: absolute;
    top: 25px;
    right: 25px;
    cursor: pointer;
    height: 38px;
    padding-top: 7px;
    &.credits {
      z-index:1;
      .line-1, .line-2 {
        background: $red;
      }
    }
    .line-1 {
      width: 24px;
      height: 2px;
      transform: rotate(45deg) translateY(1px);
      transform-origin: 50%;
      background: white;
      transition: all 0.5s ease;
    }
    &:hover .line-1 {
      transform: rotate(-0deg) translateY(1px);
    }
    .line-2 {
      width: 24px;
      height: 2px;
      transform: rotate(-45deg) translateY(-1px);
      transform-origin: 50%;
      background: white;
      transition: all 0.5s ease;
    }
    &:hover .line-2 {
      transform: rotate(0deg) translateY(-1px);
    }
  }
}
.wim-focus-titles {
  position: fixed;
  height: calc(100% - 10vh);
  margin-top: 10vh;
}
.wim-focus-picture img{
  position: absolute;
  width: 200px;
  margin-left: 30%;
}
.wim-focus-content {
  height: calc(100% - 10vh);
  margin-top: 10vh;
  margin-bottom: 10vh;
  .wim-focus-paragraph {

  }
  .wim-focus-quote {
    margin: 5% 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    .wim-focus-quote-svg img{
      background: transparent;
      cursor: pointer;
    }
    .wim-focus-quote-text {
      margin-left:5%;
    }
  }
  .wim-focus-image img{
    object-fit: cover;
    height: 100%;
    width: 100%;
  }
  .wim-focus-video {
    position: relative;
    padding-bottom: 56.25%;
    video {
      background: transparent;
      max-width: none;
      width: calc(100% + 2px);
      position: absolute;
      left: -1px;
      top: 0;
    }
  }
}

@media(max-width:768px) {
  .wim-focus-picture {
    img {
      position: static;
      margin-left: 15%;
      width: 50%;
    }
  }
  .wim-focus-name {
    margin-left: 15%;
    margin-top: 15px;
  }
  .wim-focus-component {
    z-index: 10;
  }
 .wim-focus-container {
   padding: 0 10px;
   overflow: scroll;
 }
 .wim-close-container {
   height: 8vh;
   width: 100vw;
   background: $black;
   z-index: 6;
   padding: 40px 20px;
 }
 .wim-focus-content {
   overflow: visible;
   padding:0;
   margin-top: 0px;
   margin-bottom: 30px;
   .wim-focus-quote {
     flex-direction: column;
     .wim-focus-quote-text {
       margin: 0;
       margin-top: 15px;
     }
   }
 }
 .wim-focus-titles {
  position: relative;
  height: calc(100% - 100px);
  margin-top: 100px;
}
}
</style>